<div class="container py-5">
    <div class="section-title">
        <h2>Führerscheinklassen bei Tommys</h2>
        <div class="bar"></div>
        <p>Bei Tommys Fahrschule findest du genau die Führerscheinklasse, die zu deinem Leben passt. Ob klassisch, mit Anhänger oder Automatik – wir erklären dir den Unterschied!</p>
    </div>

    <div class="row align-items-start">
        <div class="col-lg-6 col-md-12">
            <div class="about-content">
                <h3 class="mt-4">Klasse B – Der klassische Autoführerschein</h3>
                <div class="bar"></div>
                <p>Mit dem Führerschein Klasse B darfst du:</p>
                <ul>
                    <li>PKW bis 3.500 kg und max. 8 Sitzplätze (ohne Fahrer)</li>
                    <li>Anhänger bis 750 kg oder schwerer, wenn das Gesamtgewicht 3.500 kg nicht übersteigt</li>
                </ul>
                <p>Ideal für den Alltag – ob Stadtverkehr oder Urlaubsreise.</p>

                <h3 class="mt-4">Klasse BE – Für große Anhänger</h3>
                <div class="bar"></div>
                <p>Erweitere deinen Klasse B Führerschein für größere Anhänger:</p>
                <ul>
                    <li>Zugfahrzeug Klasse B + Anhänger über 750 kg</li>
                    <li>Gesamtkombination bis max. 7.000 kg</li>
                </ul>
                <p>Perfekt für Pferdeanhänger, Wohnwagen oder größere Transporte.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="about-content">
                <h3 class="mt-4">B96 – Die Zwischenlösung</h3>
                <div class="bar"></div>
                <p>Für mehr Flexibilität ohne vollständige BE-Ausbildung:</p>
                <ul>
                    <li>Zugfahrzeug Klasse B + Anhänger über 750 kg</li>
                    <li>Gesamtkombination bis max. 4.250 kg</li>
                    <li>Nur theoretische Schulung + Fahrtraining – keine Prüfung!</li>
                </ul>
                <p>Praktisch und schneller gemacht als BE.</p>

                <h3 class="mt-4">B197 – Automatik + Schaltung = Flexibilität</h3>
                <div class="bar"></div>
                <p>Du willst entspannt mit Automatik lernen, aber trotzdem später Schaltwagen fahren?</p>
                <ul>
                    <li>Prüfung auf Automatikfahrzeug</li>
                    <li>Nachweis von mind. 10 Schaltstunden + Fahrlehrerbescheinigung</li>
                    <li>Kein Automatikeintrag im Führerschein!</li>
                </ul>
                <p>Modern, zukunftssicher und absolut flexibel – genau wie wir bei Tommys.</p>

                <div class="about-btn mt-4">
                    <a routerLink="/kontakt" class="default-btn">Jetzt Beratung sichern <span></span></a>
                </div>
            </div>
        </div>
    </div>
</div>
